import React from "react";
import { useState, useEffect } from "react";
import { useForm, ValidationError } from "@formspree/react";

const Contact = () => {
  const [state, handleSubmit] = useForm("xdkgjrwr");
  const [isMobile, setIsMobile] = useState(window.innerWidth < 768);

  useEffect(() => {
    const handleResize = () => {
      setIsMobile(window.innerWidth < 768);
    };

    // Add resize event listener
    window.addEventListener("resize", handleResize);

    // Run once to ensure it's accurate even after initial render
    handleResize();

    // Clean up the event listener on unmount
    return () => {
      window.removeEventListener("resize", handleResize);
    };
  }, []);

  if (state.succeeded) {
    return <p>Thanks for joining!</p>;
  }

  if (isMobile) {
    return (
      <div>
        <h1>Contact Us</h1>
        <p>Email: info@auditingfirm.com</p>
        <p>Phone: +123-456-7890</p>
      </div>
    );
  }
  return (
    <div className="page-wrapper">
      <div className="page-hero-text-wrapper">
        <div className="page-hero-text">Contact Us</div>
      </div>
      <div className="page-body-wrapper">
        <div className="contact-body-wrapper">
          <div className="contact-page-forms-wrapper">
            <div className="contact-page-form-header">Get in Touch</div>
            <form className="contact-page" onSubmit={handleSubmit}>
              <div className="contact-form-wrapper">
                <label className="contact-page" htmlFor="title">
                  Title
                </label>
                <select
                  className="contact-page"
                  id="title"
                  name="title"
                  defaultValue=""
                >
                  <option className="contact-page" value="" disabled>
                    Select Title
                  </option>
                  <option className="contact-page" value="mr">
                    Mr.
                  </option>
                  <option className="contact-page" value="mrs">
                    Mrs.
                  </option>
                  <option className="contact-page" value="ms">
                    Ms.
                  </option>
                  <option className="contact-page" value="dr">
                    Dr.
                  </option>
                </select>
                <ValidationError
                  prefix="title"
                  field="title"
                  errors={state.errors}
                />
              </div>
              <div className="contact-page-form-wrapper">
                <div className="contact-form-wrapper">
                  <label className="contact-page" htmlFor="first-name">
                    First Name
                  </label>
                  <input
                    className="contact-page"
                    id="first-name"
                    type="text"
                    name="firstName"
                    placeholder="First Name"
                  />
                  <ValidationError
                    prefix="First Name"
                    field="firstName"
                    errors={state.errors}
                  />
                </div>
                <div className="contact-form-wrapper">
                  <label className="contact-page" htmlFor="last-name">
                    Last Name
                  </label>
                  <input
                    className="contact-page"
                    id="last-name"
                    type="text"
                    name="lastName"
                    placeholder="Last Name"
                  />
                  <ValidationError
                    prefix="Last Name"
                    field="lastName"
                    errors={state.errors}
                  />
                </div>
              </div>
              <div className="contact-page-form-wrapper">
                <div className="contact-form-wrapper">
                  <label className="contact-page" htmlFor="email">
                    Email
                  </label>
                  <input
                    className="contact-page"
                    id="email"
                    type="email"
                    name="email"
                    placeholder="example@email.com"
                  />
                  <ValidationError
                    prefix="Email"
                    field="email"
                    errors={state.errors}
                  />
                </div>
                <div className="contact-form-wrapper">
                  <label className="contact-page" htmlFor="contact-number">
                    Contact Number
                  </label>
                  <input
                    className="contact-page"
                    id="contact-number"
                    type="tel"
                    name="contactNumber"
                    placeholder="Contact Number"
                  />
                  <ValidationError
                    prefix="Contact Number"
                    field="contactNumber"
                    errors={state.errors}
                  />
                </div>
              </div>
              <div className="contact-textarea-wrapper">
                <label className="contact-page" htmlFor="remarks">
                  Remarks
                </label>
                <textarea
                  className="contact-page"
                  id="notes"
                  name="notes"
                  placeholder="Enter your remarks here..."
                  rows={8}
                />
                <ValidationError
                  prefix="Notes"
                  field="notes"
                  errors={state.errors}
                />
              </div>
              <button
                className="contact-form"
                type="submit"
                disabled={state.submitting}
              >
                Submit
              </button>
            </form>
          </div>
          <div className="contact-details-wrapper">
            <div className="contact-details-header">Find Us</div>
            <div className="contact-map-wrapper">
              <iframe
                className="contact-map"
                src="https://www.google.com/maps/embed?pb=!1m14!1m12!1m3!1d1249.076520491054!2d85.32181336710818!3d27.688817308420358!2m3!1f0!2f0!3f0!3m2!1i1024!2i768!4f13.1!5e0!3m2!1sen!2snp!4v1747828642180!5m2!1sen!2snp"
                allowFullScreen
                loading="lazy"
                referrerPolicy="no-referrer-when-downgrade"
                title="S.B Sharma Location"
              />
              <div />
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};

export default Contact;
